<template>
  <div
    class="h-100 d-flex align-items-center justify-content-center p-1 animate__animated animate__fadeIn dropship-mfg-info"
    style="max-height: 5em;max-width: 10em;margin: 0 auto;"
    data-bs-toggle="modal"
    data-bs-target="#dropshipDetail"
    @click="showNotes">
    <strong
      v-if="showName"
      class="mx-2 mt-2 text-muted">
      <h6 title="Click here for more info">
        <i
          class="fa fa-info-circle"
          style="font-size: 18px;"/>
        {{ mfg.super_buyline ? mfg.super_buyline_name || mfg.mfg :  mfg.mfg  }}
      </h6>
    </strong>
    <img
      v-else
      :src="mfg.super_buyline ? mfg.logo2 : mfg.logo"
      :style="condense ? {'height': '4vh'} : {'height': '6em'}"
      class="img-fluid">
  </div>
</template>

<script setup>
  import { useStore } from 'vuex'

  // Initialize
  const props = defineProps(['mfg', 'showName', 'condense'])
  const store = useStore()

  // Methods
  const showNotes = ()=>{
    store.dispatch('dropshipSetModalViewType', 'notes')
  }
</script>

<style scoped>
  .dropship-mfg-info:hover{
    cursor:pointer;
    scale: 1.1;
    transition: all 50ms ease-in;
  }
</style>